const genders = require('./genders');
const userTypes = require('./user-types');
const questionTypes = require('./question-types');
const OAUTH_API_TYPES = require('./oauth-callback-type');
const invitations = require('./invitations');
const EMAIL_STATUS = require('./email-status');
const emailActions = require('./email-actions');
const days = require('./days');
const timeZones = require('./time-zones');
const CONVERSATION_EVENTS = require('./conversation-events');
const ACL_TYPES = require('./conversation-events');
const SYSTEM_MESSAGE = require('./system-messages');
const SYSTEM_MESSAGE_HANDLERS = require('./system-message-handlers');
const assessments = require('./assessments');
const patientAssessmentsData = require('./patient-assessments-data');
const files = require('./files');
const logicJumpTypes = require('./logic-jump-types');
const actionItems = require('./action-items');
const recommendation = require('./recommendation');
const devices = require('./devices');
const patientsListColumns = require('./patients-list-columns');
const patientGoals = require('./patient-goals');
const patientStatuses = require('./patient-status');
const providerRoles = require('./provider-roles');
const providerRoleTypes = require('./provider-role-types');
const complexFiltersTypes = require('./complex-filters-types');
const search = require('./search');
const loggingModalTypes = require('./logging-modal-types');
const exercisesList = require('./exercise-list');
const foods = require('./foods');
const domoSections = require('./domo-sections');
const appointments = require('./appointments');
const virtualVisits = require('./virtual-visits');
const reminderTypes = require('./reminder-types');
const cronTab = require('./cronTab');
const cronJobsList = require('./cronJobsList');
const ehr = require('./ehr');
const tokenErrorMessagesTypes = require('./token-error-messages-types');
const platformActionsList = require('./platform-actions-list');
const medicalStatus = require('./medical-status');
const googleSettings = require('./google');
const featureFlagging = require('./feature-flagging');
const providerStatuses = require('./provider-statuses');
const accountInfoStatus = require('./account-info-status');
const bmiCalculation = require('./bmi-calculation');
const twoFactorAuthenticationTypes = require('./two-factor-authentication-types');
const notifications = require('./notifications');
const nutritionGoals = require('./nutrition-goals');
const patientActivityTypes = require('./patient-activity-types');
const livingPlateMealPlans = require('./living-plate-meal-plans');
const nutrientNames = require('./nutrient-names');
const passwordExpControl = require('./password-control');
const exerciseIntensity = require('./exercise-intensity');
const rpm = require('./rpm');
const pendo = require('./pendo');
const launchDarklyUser = require('./launchDarkly');
const athenaSync = require('./athena-sync');
const calendarViews = require('./calendar-views');
const COUNTRY_CODES = require('./country-codes');
const ssoPartners = require('./sso-partners');
const API_LOG_STATUS = require('./api-log-status');
const weightTypes = require('./weight-types');
const assessmentsQuestions = require('./assessments-questions-constant-helper');
const withingsMeasurementGroups = require('./withings-measurement-groups');
const careTeamProviders = require('./care-team-providers');
const constants = require('./constants');
const patientSummaryMapping = require('./patient-summary-extract');

const SANITY_LEGAL_LD_FLAG_KEY = 'sanity-poc-staging';

module.exports = {
  genders,
  userTypes,
  questionTypes,
  OAUTH_API_TYPES,
  invitations,
  EMAIL_STATUS,
  emailActions,
  days,
  timeZones,
  CONVERSATION_EVENTS,
  ACL_TYPES,
  SYSTEM_MESSAGE,
  SYSTEM_MESSAGE_HANDLERS,
  assessments,
  patientAssessmentsData,
  files,
  logicJumpTypes,
  actionItems,
  recommendation,
  devices,
  patientsListColumns,
  patientGoals,
  patientStatuses,
  providerRoles,
  providerRoleTypes,
  complexFiltersTypes,
  search,
  loggingModalTypes,
  exercisesList,
  foods,
  domoSections,
  appointments,
  virtualVisits,
  reminderTypes,
  cronTab,
  cronJobsList,
  ehr,
  tokenErrorMessagesTypes,
  platformActionsList,
  medicalStatus,
  googleSettings,
  featureFlagging,
  providerStatuses,
  accountInfoStatus,
  bmiCalculation,
  twoFactorAuthenticationTypes,
  notifications,
  nutritionGoals,
  patientActivityTypes,
  livingPlateMealPlans,
  nutrientNames,
  passwordExpControl,
  exerciseIntensity,
  rpm,
  pendo,
  launchDarklyUser,
  athenaSync,
  calendarViews,
  COUNTRY_CODES,
  ssoPartners,
  API_LOG_STATUS,
  weightTypes,
  assessmentsQuestions,
  withingsMeasurementGroups,
  careTeamProviders,
  constants,
  patientSummaryMapping,
  legalDocumentsFromSanityLdFlag: SANITY_LEGAL_LD_FLAG_KEY,
};
